/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector } from '@ngrx/store';
import { featureSelector, selectInstanceState } from './feature.selector';
import { selectGridView } from './select-grid-view.selector';
import { selectPageInfo } from './select-page-info.selector';

const selectSortInfo = (instanceId: string) =>
  createSelector(
    createSelector(selectInstanceState(instanceId), (state) => state.sortColumn),
    createSelector(selectInstanceState(instanceId), (state) => state.sortDirection),
    (sortColumn, sortDirection) => ({ sortColumn, sortDirection }),
  );

const selectInstanceIds = createSelector(featureSelector, (state) => Object.keys(state));

const selectAnyChunkLoaded = (instanceId: string) =>
  createSelector(selectInstanceState(instanceId), (state) => state.chunkLoaded);

export const PagedGridSelectors = {
  selectPreviewState: (instanceId: string) => selectInstanceState(instanceId),
  selectPageInfo,
  selectSortInfo,
  selectGridView,
  selectInstanceIds,
  selectAnyChunkLoaded,
};
